import * as yup from 'yup'

export const int64 = yup
    .number()
    .min(-9223372036854775808)
    .max(9223372036854775807)

export function isValidEmptyValue(val: any): boolean {
  return val === '' || val == null || val === 'null'
}
